import script from "./BasicInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./BasicInfoModal.vue?vue&type=style&index=0&id=13b5d265&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b5d265"]])

export default __exports__